import { useEffect, useState } from 'react';
import type { FileStoreApi } from './fileStoreApi';
import type { FileConnector } from './fileStoreTypes';

const NO_CONNECTORS: FileConnector[] = [];

/**
 * Connectors able to supply files to this owner, for "Importer via API". The route needs the
 * deposit right, so nothing is asked while `enabled` is false; a 403, any error or an empty list
 * all answer none, which hides the entry point (PRD item 15) rather than showing an error.
 */
export const useFileConnectors = (api: FileStoreApi, ownerId: number, enabled: boolean): FileConnector[] => {
  const [connectors, setConnectors] = useState<FileConnector[]>(NO_CONNECTORS);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    let cancelled = false;
    api.connectors(ownerId).then(
      (listed) => {
        if (!cancelled) {
          setConnectors(listed);
        }
      },
      () => {
        if (!cancelled) {
          setConnectors(NO_CONNECTORS);
        }
      },
    );
    return () => {
      cancelled = true;
    };
  }, [api, ownerId, enabled]);

  return enabled ? connectors : NO_CONNECTORS;
};
